import 'es6-promise/auto';
import '@/js/helpers/closest-polyfill';
import '@/js/helpers/insert-adjacent-text-polyfill';

import jQuery from 'jquery';
import Popper from 'popper.js';
import toastr from 'toastr';
import moment from 'moment';
import 'bootstrap';

try {
    window.$ = window.jQuery = jQuery;
    window.Popper = Popper;
    window.toastr = toastr;

    moment.locale('pt-br');

    window.dump = (...values) => JSON.parse(JSON.stringify(values));
} catch (ex) {
    window.console.error(ex);
}

// Array.isArray polyfill
if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

// CustomEvent Polyfill
// @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
(function () {
    if (typeof window.CustomEvent === 'function') {
        return false;
    }

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();
